import React, { useContext } from "react";
import { observer } from "mobx-react";
import { ResultsMenuStoreContext } from "@state/context/results";
import ResultsSportItem from "./ResultsSportItem";

export default observer(function ResultsSportList() {
	const { resultMenu } = useContext(ResultsMenuStoreContext);

	if (!resultMenu) {
		return null;
	}

	return (
		<>
			{resultMenu.map((sport) => (
				<ResultsSportItem key={sport.id} sport={sport} />
			))}
		</>
	);
});
